import { useCallback } from 'react';
import { useDashboardId } from './useDashboardId';

const apiUrl = import.meta.env.VITE_API_URL || '';

export const useViewCount = () => {
  const { dashboardId } = useDashboardId();
  const previewToken = new URLSearchParams(window.location.search).get('previewToken');

  const postView = useCallback(async () => {
    if (!dashboardId || previewToken) {
      return;
    }

    await fetch(`${apiUrl}${dashboardId}/view`, {
      method: 'POST',
      credentials: 'include',
    });
  }, [dashboardId, previewToken]);

  return { postView };
};
